<template>
  <div class="feature">
    <LandingNavigation />

    <BackgroundWavy />

    <section class="banner">
      <div class="left">
        <h1>
          <span
            :style="{ background: selectedFeature.lighter }"
            class="feature-icon"
          >
            <i
              :class="selectedFeature.icon"
              :style="{ color: selectedFeature.darker }"
              class="fa"
              aria-hidden="true"
            />
          </span>
          {{ selectedFeature.title }}
        </h1>
        <h2>{{ selectedFeature.description }}</h2>
        <div class="actions">
          <!-- <button class="btn btn-primary">Sign up</button> -->
          <button
            class="request-demo"
            @click="
              $intercom.showNewMessage(`Hi there. I'd like to request a demo.`)
            "
          >
            Request Demo
          </button>
        </div>
      </div>
      <div class="right">
        <div class="highlights">
          <img
            :src="selectedFeature.highlights[1].screenshot"
            :alt="selectedFeature.tagline"
            width="370px"
          />
        </div>
      </div>
    </section>

    <section class="mobile-highlight">
      <img
        :src="selectedFeature.highlights[0].screenshot"
        :alt="selectedFeature.tagline"
        class="pointer"
        width="250px"
      />
    </section>

    <section
      v-for="(highlight, index) in selectedFeature.highlights"
      :key="index"
      :id="
        highlight.tagline
          .toLowerCase()
          .replace(/\./, '')
          .split(' ')
          .join('-')
      "
      :class="{ 'mobile-top': index === 0 }"
      class="highlight"
    >
      <div :class="{ reverse: index % 2 !== 0 }" class="graphic">
        <img :src="highlight.graphic" :alt="highlight.tagline" width="100%" />
      </div>

      <div class="description">
        <span class="tagline">{{ highlight.tagline }}</span>
        <h2 class="title">{{ highlight.title }}</h2>
        <p
          v-for="(sentence, idx) in highlight.description"
          :key="idx"
          class="sentence"
          v-html="sentence"
        />
      </div>
    </section>

    <section class="more-features full-width-div">
      <div class="header">
        <h2>Explore other features</h2>
        <p class="lead">See all the ways we can help your legal team grow.</p>
      </div>

      <div class="features">
        <router-link
          v-for="(feature, idx) in getRandomHighlights()"
          :to="`/features/${feature.alias}`"
          :key="idx"
          tag="div"
          class="feature pointer"
        >
          <span :style="{ background: feature.lighter }" class="feature-icon">
            <i
              :class="feature.icon"
              :style="{ color: feature.darker }"
              class="fa"
              aria-hidden="true"
            />
          </span>
          <p class="lead mt-3">{{ feature.title }}</p>
          <p>{{ feature.highlights[0].tagline }}</p>
          <button class="learn-more mt-3">learn more</button>
        </router-link>
      </div>

      <Footer />
    </section>
  </div>
</template>

<script>
import features from "./features";
import Footer from "./Footer.vue";
import LandingNavigation from "./LandingNavigation.vue";
import BackgroundWavy from "./BackgroundWavy.vue";

import _ from "lodash";

export default {
  components: {
    BackgroundWavy,
    Footer,
    LandingNavigation
  },

  computed: {
    features() {
      return features;
    }
  },

  created() {
    this.selectedFeature = _.find(this.features["legal"], {
      alias: this.$route.params.featureName
    });
  },

  mounted() {
    if (this.$route.hash) {
      const highlightName = this.$route.hash.replace(/#/, "");
      const highlightElement = document.getElementById(highlightName);
      window.scrollTo(0, highlightElement.offsetTop);
    } else {
      window.scrollTo(0, 0);
    }
  },

  data() {
    return {
      selectedFeature: null
    };
  },

  methods: {
    generateRandomNum(min, max) {
      return Math.floor(Math.random() * (max - min + 1) + min);
    },

    getRandomHighlights() {
      const result = [];
      let features = this.features["legal"]
        .slice()
        .filter(feature => Boolean(feature.highlights));
      _.remove(features, { alias: this.selectedFeature.alias });

      for (var i = 0; i < 4; i++) {
        let randomIndex = this.generateRandomNum(0, features.length - 1);
        result.push(features[randomIndex]);
        features.splice(randomIndex, 1);
      }

      return result;
    }
  },

  prop: ["featureName"]
};
</script>

<style lang="scss" scoped>
.feature {
  .feature-icon {
    display: inline-flex;
    justify-content: center;
    align-items: center;
    border-radius: 50%;

    width: 60px;
    height: 60px;

    box-shadow: 0 2px 3px rgba(50, 50, 93, 0.11), 0 1px 9px rgba(0, 0, 0, 0.08);

    i {
      font-size: 30px;
    }
  }

  section.banner {
    display: grid;
    grid-template-columns: 50% auto;
    margin-top: 20vh;
    position: relative;

    .left {
      h1 {
        font-size: 40px;
        font-weight: 700;
      }

      h2 {
        font-size: 27px;
        color: #767ead;
        line-height: 37px;
        font-weight: 500;

        margin-top: 25px;
      }

      #selectIndustry {
        appearance: none;
        -webkit-appearance: none;
        -moz-appearance: none;
        border: none;
        box-shadow: none;
        padding: 0;
        margin: 0;
        /* needed for Firefox: */
        overflow: hidden;
        background: none;

        // style the same as the h1
        font-size: 60px;
        font-weight: 700;

        width: 275px;

        &.wider {
          width: 405px;
        }

        &:focus {
          outline: 0;
        }
      }

      p.lead {
        margin: 0 0 50px;
      }

      .actions {
        margin: 50px 0 100px;
      }
    }

    .right {
      .highlights {
        position: absolute;
        top: -50px;
        left: 60%;
        width: 1000px;
      }
    }
  }

  section.mobile-highlight {
    display: none;
    position: absolute;
    left: 0;
    width: 100%;
    text-align: center;

    background: linear-gradient(120deg, #a34aff, #2780e3);

    img {
      margin-top: -50px;
    }
  }

  section.highlight {
    display: grid;
    grid-template-columns: 50% auto;
    margin: 25vh 0;
    height: 600px;
    align-items: center;
    justify-items: center;

    .graphic {
      order: 0;

      &.reverse {
        order: 1;
      }
    }

    .description {
      padding: 0 3em;

      .tagline {
        text-transform: uppercase;
        font-size: 13px;
        letter-spacing: 1px;
        font-weight: 600;
        color: #2780e3;
      }

      .title {
        margin: 20px 0 50px;
        font-weight: 700;
      }

      .sentence {
        font-size: 20px;
        color: #767ead;
      }
    }
  }

  section.more-features {
    display: grid;
    grid-template-columns: auto;
    padding: 150px 0 0 0;
    width: 100%;
    align-items: center;
    justify-items: center;
    background: #f7f9ff;

    .header {
      text-align: center;
      padding: 0 20px;

      h2 {
        font-weight: 700;
      }
    }

    .features {
      display: grid;
      grid-template-columns: 1fr 1fr 1fr 1fr;
      grid-gap: 10vw;
      margin-top: 100px;

      .feature {
        text-align: center;
        box-sizing: border-box;
      }
    }
  }

  // MOBILE/TABLET VIEW
  @media (min-width: 0) and (max-width: 768px) {
    section.banner {
      grid-template-columns: 100%;
      margin-top: 10px;
      text-align: center;

      .right {
        display: none;
      }

      h1 {
        font-size: 30px;
      }
    }

    section.mobile-highlight {
      display: block !important;
    }

    section.highlight {
      grid-template-columns: 100%;
      margin: 60px 0;
      height: 100%;
      justify-items: left;

      &.mobile-top {
        margin-top: 375px;
      }

      .description {
        padding: 0;
      }

      .graphic {
        display: none;
      }
    }

    section.more-features {
      .features {
        grid-template-columns: 100%;
      }
    }
  }
}
</style>
